import { Component, OnInit, OnDestroy, SimpleChanges, Input } from '@angular/core';
import { StorageService } from '../../tools/storage.service';
import { IxellAPIService, Roles, IUserRenault, IColorUserV1, ICtcV1, UnisiteService, IDocumentV1, LoginData } from '../../tools/api.service';
import { ActivationLight } from '../../models/activationlight';
import { HeaderService } from '../../tools/header.service';
import { ErrorService } from '../../tools/error.service';
import { ActivatedRoute } from '@angular/router';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Utils } from 'src/app/tools/utils';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SelectionModel } from '@angular/cdk/collections';
import { Constants } from '../../entities/Constants';
import { LogInService } from '../../tools/login-service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Language } from '../../entities/Language';

import { Observable } from 'rxjs/internal/Observable';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { MatListItem } from '@angular/material/list';


@Component({
    selector: 'document',
    templateUrl: './document.component.html',
    styleUrls: ['./document.component.scss']
})

export class DocumentComponent implements OnInit, OnDestroy {

    documentLstToShow: IDocumentV1[] = [];
    breakpoint: number;
    heightSize: string;
    buttonRetour: boolean;
    idParentRetour: number[] = [];
    dataLocalUrl: any;

    login: string;
    password: string;
    country: string;

    isContentLoading: boolean = false;

    //private roleSub: any;
    private documentSub: any;
    private documentLogInSub: any;

    constructor(public storage: StorageService, private api: IxellAPIService, public headerService: HeaderService, private errorService: ErrorService, private domSanitizer: DomSanitizer, private logInService: LogInService, private route: ActivatedRoute) { }

    language: string = "";
    singleEvent$: BehaviorSubject<Event>;
    languageIsInit: boolean = false;
    documentContainValue: boolean = true;

    selectedDocumentIDTitre: number = 0;

    ngOnInit() {
        ///*----------------------------------------------------------------------------------------------------*/console.log("ngOnInit");

        ///*----------------------------------------------------------------------------------------------------*/console.log(this.route);
        ///*----------------------------------------------------------------------------------------------------*/console.log(this.route.snapshot.queryParams);

        this.initLanguage();

        this.login = this.route.snapshot.queryParams['login'];
        if (this.login) {
            this.password = this.route.snapshot.queryParams['pwd'];
            if (this.password) {

                (document.getElementsByClassName("header")[0] as HTMLElement).style.display = 'none';

                let data: LoginData = new LoginData();
                data.login = this.login;
                data.password = this.password;
                ///*----------------------------------------------------------------------------------------------------*/console.log(data);
                this.documentLogInSub = this.api.logInDocument(data).subscribe(async data => {
                    this.logInService.parseLogIn(data);
                    await this.delay(50);
                    this.country = this.route.snapshot.queryParams['pays'];
                    if (!this.country) { this.country = "FR"; }
                    this.initDocument();
                });
            }
        }
        else {
            this.country = this.storage.get("country");
            ///*----------------------------------------------------------------------------------------------------*/console.log(this.country);
            ///*----------------------------------------------------------------------------------------------------*/console.log(this.country == "null");
            if (!this.country) { this.country = "FR"; }
            //if (!this.country) { this.country = "EN"; }
            this.initDocument();
        }

    }

    private delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    private initLanguage() {
        ///*----------------------------------------------------------------------------------------------------*/console.log("function: initLanguage");
        ///*----------------------------------------------------------------------------------------------------*/console.log("this.headerService.currentLangue.subscribe");
        this.headerService.currentLangue.subscribe(event => {
            console.log(event);
            this.singleEvent$ = new BehaviorSubject(event);
            this.language = event;
            if (this.languageIsInit) {
                this.SelectDocument();
            } else {
                this.languageIsInit = true;
            }
        });
    }

    initDocument() {

        ///*----------------------------------------------------------------------------------------------------*/console.log("ngOnInit");
        this.headerService.changeTitle("Documents");
        this.headerService.changeLogo(null);
        this.headerService.changeCanBack(true);

        //this.roleSub = this.headerService.currentRole.subscribe(role => this.roleSub = role);
        //this.headerService.verifyRole();

        ///*----------------------------------------------------------------------------------------------------*/console.log("documentSub");

        this.SelectDocument();

        if (window.innerWidth <= 576)
            this.breakpoint = 2;
        else if (window.innerWidth <= 980)
            this.breakpoint = 5;
        else
            this.breakpoint = 6;
        this.heightSize = (window.innerWidth <= 600) ? "4:3" : "6:1";

    }

    public SelectDocument() {
        this.isContentLoading = true;

        ///*----------------------------------------------------------------------------------------------------*/console.log("function: SelectDocument");
        this.documentSub = this.api.getDocuments(this.language, this.country).subscribe(data => {
            ///*----------------------------------------------------------------------------------------------------*/console.log(data);
            this.documentContainValue = data.length > 0;

            this.isContentLoading = false;

            this.documentLstToShow = data;
            this.buttonRetour = false;
            this.idParentRetour = [];
            this.dataLocalUrl = null;
        }, error => {
            console.error(error);
            if (this.documentSub != null) { this.documentSub.unsubscribe(); }
        });

    }

    public SelectDocumentRetour() {
        //this.isContentLoading = true;
        this.idParentRetour.pop();
        if (this.idParentRetour.length > 0) {
            var document = new IDocumentV1();
            document.idTitre = this.idParentRetour.pop();
            document.doc = null;
            this.SelectDocumentEnfant(document);
        } else {
            this.SelectDocument();
        }
    }

    public SelectDocumentEnfant(document: IDocumentV1, listItem?: MatListItem) {
        if (this.selectedDocumentIDTitre > 0 && this.selectedDocumentIDTitre === document.idTitre) {
            this.selectedDocumentIDTitre = 0;
            this.dataLocalUrl = null;
            return;
        }

        this.isContentLoading = true;

        if (document.haveDoc) {
            ///*----------------------------------------------------------------------------------------------------*/console.log(document.doc);
            //var buffer = new ArrayBuffer(document.doc);

            this.documentSub = this.api.getDocumentsPDF(document.idTitre, this.language, this.country).subscribe(data => {
                ///*----------------------------------------------------------------------------------------------------*/console.log(data);

                this.isContentLoading = false;
                this.selectedDocumentIDTitre = document.idTitre;

                const byteCharacters = atob(data.doc);
                ///*----------------------------------------------------------------------------------------------------*/console.log("byteCharacters: ", byteCharacters);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                ///*----------------------------------------------------------------------------------------------------*/console.log("byteNumbers: ", byteNumbers);

                const byteArray = new Uint8Array(byteNumbers);
                ///*----------------------------------------------------------------------------------------------------*/console.log("byteArray: ", byteArray);
                var file = new Blob([byteArray], { type: 'application/pdf' });
                ///*----------------------------------------------------------------------------------------------------*/console.log("file: ", file);
                this.dataLocalUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(file));

                setTimeout(() => {
                    if (listItem)
                        listItem._elementRef.nativeElement.scrollIntoView(true);
                }, 50);

            }, error => {
                console.error(error);
                if (this.documentSub != null) { this.documentSub.unsubscribe(); }
            });

        } else {
            this.idParentRetour.push(document.idTitre);
            this.documentSub = this.api.getDocumentsEnfant(document.idTitre, this.language, this.country).subscribe(data => {
                ///*----------------------------------------------------------------------------------------------------*/console.log(data);

                this.isContentLoading = false;

                this.documentLstToShow = data;
                this.buttonRetour = true;
            }, error => {
                console.error(error);
                if (this.documentSub != null) { this.documentSub.unsubscribe(); }
            });
        }
    }

    onResize(event: any) {
        if (event.target.innerWidth <= 576)
            this.breakpoint = 2;
        else if (event.target.innerWidth <= 980)
            this.breakpoint = 5;
        else
            this.breakpoint = 6;
        this.heightSize = (window.innerWidth <= 600) ? "4:3" : "6:1";
    }

    ngOnDestroy() {
        //if (this.roleSub != null) { this.roleSub.unsubscribe(); }
        if (this.documentSub != null) { this.documentSub.unsubscribe(); }
    }
}
